import { render, staticRenderFns } from "./AiRecommendationDialog.vue?vue&type=template&id=21cb246e"
import script from "./AiRecommendationDialog.vue?vue&type=script&lang=js"
export * from "./AiRecommendationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports